export default __webpack_public_path__ + "static/media/bg-dark.ffb9199c.png";